import { render, staticRenderFns } from "./ParticipantCategoryList.vue?vue&type=template&id=2376c667&"
import script from "./ParticipantCategoryList.vue?vue&type=script&lang=js&"
export * from "./ParticipantCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports